<template>
    <div>
        <div class="centerItem">
            <label class="name">姓名<span v-if="isRequired">*</span></label>
            <input
                v-if="fir"
                placeholder="请输入姓名"
                :class="['txtin', {'inputRequired': isRequired}]"
                v-model="formData.Name"
                autocomplete="off"
            />
            <label v-if="second" class="look">{{ formData.Name }}</label>
        </div>
        <div class="centerItem">
          <div style="display:flex;align-items:center">
            <label class="name">出生年月日<span v-if="isRequired">*</span></label>
            <date-select v-if="toRender" :fir="fir" :second="second" :initDateTime="formData.Birthday" @getDate="getDate" />
          </div>
        </div>
        <div class="centerItem">
          <div style="display:flex;align-items:center">
            <label class="name">性别<span v-if="isRequired">*</span></label>
            <template v-if="fir">
              <input
                v-model="formData.Sex"
                value="1"
                class="radio_dot"
                type="radio"
                :name="type+'SexRadio'"
              />男
              <input
                v-model="formData.Sex"
                value="2"
                class="radio_dot"
                type="radio"
                :name="type+'SexRadio'"
              />女
            </template>
            <label v-if="second" class="look">{{ formData.Sex == 1 ? '男' : '女' }}</label>
          </div>
        </div>
        <div v-if="isSpecific" class="centerItem">
            <label class="name">民族<span v-if="isRequired">*</span></label>
            <input
                v-if="fir"
                placeholder="请输入民族"
                :class="['txtin', {'inputRequired': isRequired}]"
                v-model="formData.Nation"
                autocomplete="off"
            />
            <label v-if="second" class="look">{{ formData.Nation }}</label>
        </div>
        <div v-if="isSpecific" class="centerItem">
          <div style="display:flex;align-items:center">
            <label class="name">毕业院校<span v-if="isRequired">*</span></label>
            <template v-if="fir">
                <input
                    v-model="formData.Graduate"
                    value="大陆及港澳台"
                    class="radio_dot"
                    type="radio"
                    :name="type+'GraduateRadio'"
                />大陆及港澳台
                <input
                    v-model="formData.Graduate"
                    value="国外"
                    class="radio_dot"
                    type="radio"
                    :name="type+'GraduateRadio'"
                />国外
            </template>
            <label v-if="second" class="look">{{ formData.Graduate }},{{ formData.School }}</label>
          </div>
        </div>
        <div v-if="isSpecific && fir" class="centerItem">
            <label class="name"></label>
            <input
                placeholder="请输入学校名字"
                :class="['txtin', {'inputRequired': isRequired}]"
                v-model="formData.School"
                autocomplete="off"
            />
        </div>
        <div class="centerItem">
            <label class="name">户籍所在地<span v-if="isRequired">*</span></label>
            <template v-if="fir">
                <select
                    v-model="formData.BirthProvince"
                    class="types margin-r-20"
                    @change="provinceSel('Birth')"
                >
                    <option
                    v-for="(item, index) in provinceOp"
                    :key="index"
                    :value="item.name"
                    >{{ item.name }}</option
                    >
                </select>
                <input
                    v-if="formData.BirthProvince==='海外'"
                    placeholder="请输入户籍所在地"
                    :class="['txtin', {'inputRequired': isRequired}]"
                    v-model="formData.BirthCity"
                    autocomplete="off"
                />
                <select
                    v-else
                    v-model="formData.BirthCity"
                    class="types"
                >
                    <option
                    v-for="(item, index) in BirthCityOp"
                    :key="index"
                    :value="item.name"
                    >{{ item.name }}</option
                    >
                </select>
            </template>
            <label v-if="second" class="look">{{ formData.BirthProvince }}/{{ formData.BirthCity }}</label>
        </div>
        <div v-if="isCurrentAddr" class="centerItem">
            <label class="name">常住地区<span v-if="isRequired">*</span></label>
            <template v-if="fir">
                <select
                    v-model="formData.CurrentProvince"
                    class="types margin-r-20"
                    @change="provinceSel('Current')"
                >
                    <option
                    v-for="(item, index) in provinceOp"
                    :key="index"
                    :value="item.name"
                    >{{ item.name }}</option
                    >
                </select>
                <input
                    v-if="formData.CurrentProvince==='海外'"
                    placeholder="请输入常住地区"
                    :class="['txtin', {'inputRequired': isRequired}]"
                    v-model="formData.CurrentCity"
                    autocomplete="off"
                />
                <select
                    v-else
                    v-model="formData.CurrentCity"
                    class="types"
                >
                    <option
                    v-for="(item, index) in CurrentCityOp"
                    :key="index"
                    :value="item.name"
                    >{{ item.name }}</option
                    >
                </select>
            </template>
            <label v-if="second" class="look">{{ formData.CurrentProvince }}/{{ formData.CurrentCity }}</label>
        </div>
        <div v-if="isJoin" :class="['centerItem', {'margin-b-0': !isFrequery}]">
          <div style="display:flex;align-items:center">
            <label class="name name-auto">是否有项目曾参加过金鸡电影创投大会<span v-if="isRequired">*</span></label>
            <template v-if="fir">
              <input
                v-model="formData.IsJoinDeclaration"
                value="0"
                class="radio_dot"
                type="radio"
                :name="type+'IsJoinDeclarationRadio'"
              />否
              <input
                v-model="formData.IsJoinDeclaration"
                value="1"
                class="radio_dot"
                type="radio"
                :name="type+'IsJoinDeclarationRadio'"
              />是
            </template>
            <label v-if="second" class="look">{{ formData.IsJoinDeclaration == 0 ? '否' : '是' }}</label>
          </div>
        </div>
        <div v-if="isFrequery" class="centerItem margin-b-0">
            <label class="name">参加次数<span v-if="isRequired">*</span></label>
            <input
              v-if="fir"
              placeholder="次数，仅限填写数字"
              :class="['txtin', {'inputRequired': isRequired}]"
              v-model="formData.JoinFrequery"
              autocomplete="off"
              :disabled="formData.IsJoinDeclaration==0"
              @keyup="limitDigit"
            />
            <label v-if="second" class="look">{{ formData.JoinFrequery }}</label>
        </div>
    </div>
</template>

<script>
import DateSelect from "@/views/components/DateSelect";

export default {
    components: { DateSelect },
    props: {
        type: {
            type: String,
            default: ''
        },
        fir: {
            type: Boolean,
            default: true
        },
        second: {
            type: Boolean,
            default: false
        },
        initFormData: {
            type: Object,
            default() {
                return {}
            }
        },
        isSpecific: {
            type: Boolean,
            default: false
        },
        isCurrentAddr: {
            type: Boolean,
            default: false
        },
        isJoin: {
            type: Boolean,
            default: false
        },
        isFrequery: {
            type: Boolean,
            default: false
        },
        isRequired: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            provinceOp: [],
            BirthCityOp: [],
            CurrentCityOp: [],
            formData: {
                Name: '',
                Birthday: null,
                Sex: '1',
                Nation: '',
                Graduate: '大陆及港澳台',
                School: '',
                BirthProvince: '',
                BirthCity: '',
                CurrentProvince: '',
                CurrentCity: '',
                IsJoinDeclaration: '0',
                JoinFrequery: 0,
            },
            finalFormData: {},
            toRender: true
        }
    },
    watch: {
        'formData.IsJoinDeclaration'(newVal, oldVal) {
            if(newVal == 0) {
                this.formData.JoinFrequery = 0
            }
        }
    },
    created() {
        this.provinceOp = this.$proCityOp();
        this.provinceOp.push({
            pid: "",
            name: "海外",
            code: "999999"
        })

        if(this.initFormData.id) {
            this.toRender = false;
            for(let i in this.formData) {
                this.formData[i] = this.initFormData[this.type + i];
            }
            this.$nextTick(() => {
                this.toRender = true;
                this.getCityOP('Birth');
                this.getCityOP('Current');
            })
        }
    },
    methods: {
        getCityOP(type) {
            let Province = type + 'Province'
            let cityOp = type + 'CityOp'
            if(this.formData[Province] === '海外') {
                return
            }
            let secondaryArr = ['北京市', '天津市', '上海市', '重庆市', '海南省', '香港特别行政区', '澳门特别行政区', '台湾省'];
            this[cityOp] = [];

            for(let i=0; i<this.provinceOp.length; i++) {
                if(this.formData[Province] == this.provinceOp[i].name) {
                    if(secondaryArr.indexOf(this.formData[Province]) !== -1) {
                        this.provinceOp[i].children.forEach(ele => {
                            this[cityOp] = this[cityOp].concat(ele.children);
                        })
                        break
                    } else {
                        this[cityOp] = this.provinceOp[i].children;
                        break
                    }
                }
                
            }
        },
        provinceSel(type) {
            this.formData[type + 'City'] = '';
            this.getCityOP(type);
        },
        checkForm() {
            if(!this.formData.Birthday || !this.formData.BirthProvince || !this.formData.BirthCity || (this.isSpecific && !this.formData.Graduate) || (this.isCurrentAddr && (!this.formData.CurrentProvince || !this.formData.CurrentCity))) {
                return false
            }
            return true
        },
        getDate(val) {
            this.formData.Birthday = val;
        },
        limitDigit() {
            this.formData.JoinFrequery = this.formData.JoinFrequery.replace(/[^\d]/g,'')
        }
    }
}
</script>

<style src="../../static/css/regist.css" scoped></style>
<style scoped>
.name {
    width: 130px;
}
.name-auto {
    margin-right: 20px;
    width: auto;
    min-width: 130px;
}
</style>